import { h } from 'preact';
import { BaseAnnotation } from '../base_annotation';
import { focusable } from 'utilities/accessibility';
import { COMPOSITION_TYPES, getCompositionInfo } from 'constants/annotations';
import { ControlBar } from 'rendering/components/adjacent_control_bar';

const { IMAGE } = COMPOSITION_TYPES;

export class ImageAnnotation extends BaseAnnotation {
    render () {
        const { properties = {}, content } = this.props,
            { showExpanded = false } = properties;

        return (
            <div { ...this.attrs }>
                { content && showExpanded && (<ControlBar onExpand={ this.onExpandPlayerAnnotation } onCollapse={ this.onCollapsePlayerAnnotation } styles={ this.controlBarStyles }/>)}
            </div>
        );
    }

    get legacyClasses() {
        const base = [
            'popcorn-image',
            'active',
            (this.options.transitionClass || '')
        ];

        return base.join(' ');
    }
    
    get classes() {
        return [
            ...super.classes,
            'image-annotation'
        ]
    }

    get attrs() {
        return {
            role: 'img',
            'aria-label': this.options.altText,
            className: this.classes,
            style: this.getElementStyles(),
            ...this.applyActions(this.actions),
            ...this.dataAttrs,
            ...focusable
        }
    }

    getElementStyles(...args) {
        const styles = super.getElementStyles(...args);

        return {
            ...styles,
            backgroundImage: styles.backgroundImage || `url(${this.props.content})`,
            backgroundSize: styles.backgroundSize || 'contain',
            backgroundRepeat: styles.backgroundRepeat || 'no-repeat',
            backgroundPosition: styles.backgroundPosition || 'center'
        }
    }

    static get composition() {
        return getCompositionInfo('IMAGE');
    }

    static get schemaType() {
        return 'image';
    }
}